<template>
  <div class="travelerName">
    <div style="padding:0.133rem 0;overflow:hidden">
      <div style="float:left;font-size:0.3192rem;">{{$t('system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng')}}</div>
      <div style="font-size:0.3192rem;float:right">
        <img src="/static/img/Instructions.png" style="width:0.478rem;vertical-align: middle" />
        <span style="vertical-align:middle;color:#b4c3da" @click="fillInformation">{{ $t("mall.FillInfo") }}</span>
      </div>
    </div>
    <div class="travelerName-wrapper" v-for="(CardsList, index) in CardsLists" :key="index">
      <div class="travelerName-item" v-if="!ToggleFlag">
        <div>
          <span v-if="isSelf">{{value.RoleName}}</span>
          <input v-else v-model="value.RoleName" type="text" :placeholder="$t('placeholders.UserName')" />
        </div>
        <div>{{ $t("mall.UserName") }}</div>
        <!-- <div style="font-size:0.3192rem;">
          <img src="/static/img/Instructions.png" style="width:0.478rem;vertical-align: middle" />
          <span style="vertical-align:middle;color:#b4c3da" @click="fillInformation">{{$t('mall.FillInfo')}}</span>
        </div> -->
      </div>
      <div class="border_bottom" v-if="!ToggleFlag"></div>
      <div class="travelerName-item" v-if="ToggleFlag">
        <div style="width:1.85rem">
          <input v-model="CardsList.EnglishFirstName" type="text" :placeholder="$t('placeholders.LastName')" />
        </div>
        <div>{{ $t("mall.Surname") }}</div>
      </div>
      <div class="border_bottom" v-if="ToggleFlag"></div>
      <div class="travelerName-item" v-if="ToggleFlag">
        <div style="width:1.85rem">
          <input v-model="CardsList.EnglishLastName" type="text" :placeholder="$t('placeholders.firstName')" />
        </div>
        <div>{{ $t("mall.GivenName") }}</div>
      </div>
      <div class="border_bottom"></div>
      <div class="language-toggle" v-if="BookingType && Services == 'flight' && ApplyArea != 1127" :class="{ on: ToggleFlag }" @click="toggle(CardsList)">
        <span>{{ $t("system.Chinese") }}</span>
        <span>{{ $t("system.English") }}</span>
      </div>
    </div>

    <explainStop ref="explainStop" style="background-color:#fff;overflow-y: scroll;color: #323232">
      <div class="fillInformation">
        <div class="fillInformation-title">
          <span>{{$t('system_mall_modules_travelername_tianxiexuzhi')}}</span>
          <span style="float:right" @click="close"> <img src="/static/img/close1.png" style="width:0.532rem;vertical-align:middle"/></span>
        </div>
        <div class="fillInformation-contents">
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_yitianxieshuoming')}}</p>
            <div style="font-size:0.345rem;color:#323232;">
              <p>{{$t('system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi')}}</p>
              <p>{{$t('system_mall_modules_travelername_wqbslchqqblhjsrqzsbz')}}</p>
            </div>
          </div>
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_erxinbanhuzhao')}}</p>
            <div>
              <img src="/static/img/xbhz.png" style="width:100%;" />
            </div>
          </div>
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_sanjiubanhuzhao')}}</p>
            <div>
              <img src="/static/img/jbhz.png" style="width:100%;" />
            </div>
          </div>
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_sigangaotonghangzheng')}}</p>
            <div>
              <img src="/static/img/gattxz.png" style="width:100%;" />
            </div>
          </div>
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_wutaiwantonghangzheng')}}</p>
            <div>
              <img src="/static/img/twgxz.png" style="width:100%;" />
            </div>
          </div>
          <div class="fillInformation-item">
            <p style="font-size:0.372rem;color:#323232">{{$t('system_mall_modules_travelername_liutaibaozheng')}}</p>
            <div>
              <img src="/static/img/tbz.png" style="width:100%;" />
            </div>
          </div>
        </div>
      </div>
    </explainStop>
  </div>
</template>
<style scoped>
  .travelerName {
    position: relative;
  }

  .travelerName input {
    border: none;
    height: 100%;
    width: 100%;
  }

  .travelerName input:focus {
    outline: none;
  }

  .travelerName-item {
    position: relative;
  }

  .travelerName-item > div {
    font-size: 0.399rem;
  }

  .travelerName-item > div:first-child {
    margin-left: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .travelerName-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .travelerName-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .travelerName-item input::-webkit-input-placeholder {
    color: #b6b6b6;
  }

  .travelerName-item input:-moz-placeholder {
    color: #b6b6b6;
  }

  .travelerName-item input:-ms-input-placeholder {
    color: #b6b6b6;
  }

  .fillInformation-title {
    text-align: center;
    padding: 0.532rem 0.266rem 0.532rem 0;
  }

  .fillInformation-title img {
    vertical-align: middle;
  }

  .fillInformation-title::after {
    display: block;
    clear: both;
    content: "";
  }

  .fillInformation {
    height: 100%;
    padding: 0.266rem;
    overflow-y: scroll;
  }

  .language-toggle {
    position: absolute;
    background-color: #ddd;
    font-size: 0;
    width: 72px;
    height: 22px;
    top: 1.463rem;
    right: 0.532rem;
    margin-top: -0.11rem;
  }

  .language-toggle span {
    position: relative;
    z-index: 1;
    display: inline-block;
    line-height: 22px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 0.957rem;
    height: 22px;
  }

  .language-toggle.on:after {
    transform: translate3d(0.957rem, 0, 0);
  }

  .language-toggle:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 0.957rem;
    height: 22px;
    background-color: #47f;
    transition: transform 0.3s;
  }
</style>
<script>
  import explainStop from "../../modules/explainStop.vue";
  export default {
    data() {
      return {
        cloneCardType: "",
      };
    },
    computed: {
      BookingType() {
        return this.$route.query.BookingType;
      },
      Services() {
        return this.$route.query.Services;
      },
      ApplyArea() {
        return this.$route.query.ApplyArea;
      },
      isSelf(){
        return this.profile.UserID==this.value.RoleID; 
      }
    },
    props: ["value", "CardsLists", "Types", "ToggleFlag"],

    methods: {
      fillInformation() {
        let __self = this;
        __self.$refs.explainStop.show();
      },
      close() {
        let __self = this;
        __self.$refs.explainStop.hide();
      },
      toggle(CardsList) {
        let __self = this;
        __self.ToggleFlag = !__self.ToggleFlag;
        if (__self.ToggleFlag && !(__self.Types.Card == 1139 || __self.Types.Card == 1297)) {
          __self.cloneCardType = __self.Types.Card;
          __self.Types.Card = 1139;
        } else if (__self.cloneCardType) {
          __self.Types.Card = __self.cloneCardType;
          __self.cloneCardType = null;
        }
      },
    },
    watch: {
      "Types.Card"(newVal) {
        let __self = this;
        if (__self.Services == "flight") {
          if (newVal == 1139 || newVal == 1297 || __self.ApplyArea == 1127) {
            __self.ToggleFlag = true;
          } else {
            __self.ToggleFlag = false;
          }
          // if (newVal == 1139) {
          //   __self.ToggleFlag = true
          // } else {
          //   __self.ToggleFlag = false
          // }
        }
      },
      ToggleFlag(newVal) {
        let __self = this;
        __self.$emit("ChangeToggleFlag", newVal);
      },
    },
    components: {
      explainStop,
    },
  };
</script>
